<template>
  <div class="weather-fill clearfix">
    <el-row>
      <el-col :span='24'>
        <el-tabs type="border-card" v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="基本信息" name="first">
            <div>
              <el-form label-width="50px" :model="form" :rules="rules" style="width:80%;">
                <el-form-item label="">
                  <p v-if="oldRiskLevel" class="b_p">上次备案风险等级：{{ getRiskLevelLabel(oldRiskLevel) }}</p>
                  <p class="b_p">风险等级：</p>
                  <el-radio-group v-model="form.riskLevel" size="small">
                    <el-radio :label="1">一般</el-radio>
                    <el-radio :label="2">较大</el-radio>
                    <el-radio :label="3">重大</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label=""
                              v-if="oldRiskLevel === 1 && this.form.riskLevel === 1">
                  <p class="b_p">历史一般回顾性一般，是否涉及回顾性简化备案：</p>
                  <el-radio-group v-model="form.simplifyFlag" size="small">
                    <el-radio :label="4">涉及</el-radio>
                    <el-radio :label="1">
                      不涉及，常规管理企业
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <!--<el-form-item label="">
                  <p class="b_p">企业规模：</p>
                  <el-radio-group v-model="form.enterpriseScale" size="small">
                    <el-radio :label="1">小型</el-radio>
                    <el-radio :label="2">中型</el-radio>
                    <el-radio :label="3">大型</el-radio>
                  </el-radio-group>
                </el-form-item>-->
                <el-form-item label="" style="width:300px;" prop="factoryArea">
                  <p class="b_p">厂区面积：</p>
                  <el-col :span="15">
                    <el-input v-model="form.factoryArea" placeholder="平方米" size="small" type="number"></el-input>
                  </el-col>
                  <el-col :span="6" style="padding-left: 5px;">平方米</el-col>
                </el-form-item>
                <el-form-item label="" style="width:300px;" prop="employeesNum">
                  <p class="b_p">从业人数：</p>
                  <el-col :span="15">
                    <el-input v-model="form.employeesNum" size="small" placeholder="人数" type="number"></el-input>
                  </el-col>
                  <el-col :span="6" style="padding-left: 5px;">人数</el-col>
                </el-form-item>
                <el-form-item label=""
                              v-if="saveButtonFlag === 'true' || (this.form.riskLevel === 1 && this.oldRiskLevel !==1)">
                  <p class="b_p">是否涉及简化备案：</p>
                  <el-radio-group v-model="form.simplifyFlag" size="small">
                    <el-radio :label="1">不涉及</el-radio>
                    <el-radio :label="2" :disabled="isRiskLevelHigh">涉及，不产生危险废物，所有Q值累计值小于1</el-radio>
                    <el-radio :label="3" :disabled="isRiskLevelHigh">
                      涉及，产生危险废物，所有Q值累计值小于1且年产生危险废物小于10吨
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" class="arr_b">
                  <p class="b_p">可能发生突发环境事件情景：</p>
                  <el-checkbox-group v-model="checkList" @change="changeArr">
                    <el-checkbox label="1">火灾、爆炸、泄漏等生产安全事故及可能引起的次生、衍生
                      厂外环境污染及人员伤亡事故（例如，因生产安全事故导致有毒有 害气体扩散出厂界，消防水、物料泄漏物及反应生成物，从雨水排
                      口、清净下水排口、污水排口、厂门或围墙排出厂界，污染环境等）
                    </el-checkbox>
                    <el-checkbox label="2">环境风险防控设施失灵或非正常操作（如雨水阀门不能正常
                      关闭，化工行业火炬意外灭火）
                    </el-checkbox>
                    <el-checkbox label="3">非正常工况（如开、停车等）;</el-checkbox>
                    <el-checkbox label="4">污染治理设施非正常运行;</el-checkbox>
                    <el-checkbox label="5">违法排污；</el-checkbox>
                    <el-checkbox label="6">停电、断水、停气等;</el-checkbox>
                    <el-checkbox label="7">通讯或运输系统故障;</el-checkbox>
                    <el-checkbox label="8">各种自然灾害、极端天气或不利气象条件；</el-checkbox>
                    <el-checkbox label="9">其他可能的情景。</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="风险物质" name="second">
            <RiskMaterial ref="riskMaterialRes"></RiskMaterial>
          </el-tab-pane>
          <el-tab-pane label="应急物资" name="third">
            <Emergency ref="emergency"></Emergency>
          </el-tab-pane>
          <!-- <el-tab-pane label="工艺和环境风险控制" name="fourth">
            <process ref="process"></process>
          </el-tab-pane> -->
          <el-tab-pane label="敏感目标区域" name="fifth">
            <Sensprotection ref="sensprotection" v-if="reFresh"></Sensprotection>
          </el-tab-pane>
          <el-tab-pane label="案例" name="sixth">
            <casev ref="case"></casev>
          </el-tab-pane>
          <el-tab-pane label="平面图" name="seventh">
            <planImg ref="plan"></planImg>
          </el-tab-pane>
          <el-tab-pane label="应急队伍" name="eighth">
            <EmergencyTeam ref="emergencyTeam"></EmergencyTeam>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import emer from '../../data/emer/weather.js'
import Burst from '../../data/emer/burst.js'
import RiskMaterial from './RiskMaterial'
import Emergency from './emergency'
import EmergencyTeam from './EmergencyTeam'
import Sensprotection from './Sensprotection.vue'
import planImg from './planImg.vue'
import process from './process.vue'
import casev from './case.vue'
import Apis from '../../data/api';

export default {
  data() {
    return {
      isValidateForm: true,
      activeName: 'first',
      riskGrade: 1,
      oldRiskLevel: '',
      riskLevelDegrade: false,
      // 基本信息
      form: {
        employeesNum: 0,
        enterpriseScale: 0,
        factoryArea: 0,
        planId: '',
        riskLevel: 1,
        situation: '2',
        simplifyFlag: 0,
        // twoSimplifyFlag: 1,
      },
      saveButtonFlag: JSON.parse(sessionStorage.getItem('datalistobj')).type === 0 && sessionStorage.getItem('saveButtonFlag'),
      // 多选
      checkList: [],
      checkxzList: [],
      isSave: false,
      rules: {
        factoryArea: [{
          required: true,
          message: '请输入厂区面积',
          trigger: 'blur'
        },
          {
            pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
            message: '请输入正数',
            trigger: 'blur'
          }
        ],
        employeesNum: [{
          required: true,
          message: '请输入从业人数',
          trigger: 'blur'
        },
          {
            pattern: /^[+]{0,1}(\d+)$/,
            message: '请输入正整数',
            trigger: 'blur'
          }
        ],
      },
      pageTime: 1,
      reFresh: true,
      firstIn: true
    }
  },
  watch: {
    form: {
      handler() {
        // if(this.pageTime > 3){
        this.form.subjectId = sessionStorage.subjectId;
        this.sudden_save(this.form)
        // 	this.pageTime++;
        // }else{
        // 	this.pageTime++;
        // }
      },
      deep: true
    },
    activeName: {
      handler() {
        if (this.activeName == 'second' || this.activeName == 'third') {

        }
      }
    }
  },
  beforeDestroy() {
    if (sessionStorage.save_st_res) sessionStorage.removeItem('save_st_res')
  },
  created() {
    Apis.getEnv().then((resp) => {
      this.isValidateForm = resp.isValidate;
      if (typeof resp.isValidate === 'string') {
        this.isValidateForm = resp.isValidate === 'true' ? true : false;
      }
    });
    this.get_basic_detail()
    this.sensprotection_list()
    this.getLastSuccPlanRiskLevel()
  },
  computed: {
    isRiskLevelHigh() {
      return this.form.riskLevel === 2 || this.form.riskLevel === 3;
    }
  },
  mounted() {
    var that = this;

  },
  methods: {
    getRiskLevelLabel(riskLevel) {
      switch (riskLevel) {
        case 1:
          return '一般';
        case 2:
          return '较大';
        case 3:
          return '重大';
        default:
          return '未知';
      }
    },
    changeTab(e) {
      // added by aimee
      if (e.index == '3') {
        this.reFresh = false
        this.$nextTick(() => {
          this.reFresh = true
        })
      } else if (e.index == 2) {
        if (this.firstIn) {
          this.$refs.emergency.rest();
          this.firstIn = false;
        }

      }

    },

    // 获取详情
    get_basic_detail() {
      (async () => {
        try {
          let info = await Burst.get_basic_detail({
            planId: sessionStorage.planIdval
          })
          if (info.status) {
            this.form = info.data
            this.form.enterpriseScale = 1
            sessionStorage.setItem('simplifyFlag', info.data.simplifyFlag)
            this.form.simplifyFlag = info.data.simplifyFlag;
            this.$emit('updateFileLists');
            if (info.data.situation == null) {
              this.checkList = []
            } else {
              this.checkList = info.data.situation.split(',')
            }
          }
        } catch (err) {
          this.$message.error('网络异常，请稍后重试')
        }
      })()
    },
    verifyAllResult() {

      if (!this.isValidateForm) {
        return {
          status: true,
          msg: 'ok'
        }
      }
      console.log('this.form.simp', this.form.simplifyFlag)
      // 验证基本信息
      for (let item in this.form) {
        if (!this.form[item] && item != 'oldRiskLevel') {
          console.log(item)
          return {
            status: false,
            msg: '基本信息不完善，请填写'
          }
          break
        }
      }
      // 验证“是否涉及简化备案”字段
      if ((this.saveButtonFlag === 'true' || (this.form.riskLevel === 1 && this.oldRiskLevel !== 1)) && (!this.form.simplifyFlag || this.form.simplifyFlag === '4')) {
        return {
          status: false,
          msg: '是否涉及简化备案信息不完善，请填写'
        }
      }

      // if (this.form.riskLevel === 1 && this.oldRiskLevel === 1) {
      //   // 简化备案
      //   if (!this.form.twoSimplifyFlag) {
      //     return {
      //       status: false,
      //       msg: '历史一般回顾性一般，是否涉及回顾性简化备案，请填写'
      //     }
      //   }
      // }

      // 验证风险物资
      let wz = this.$refs.riskMaterialRes.verifyResult()
      if (!wz) {
        return {
          status: false,
          msg: '风险物质信息不完善，请填写'
        }
      }

      // 应急物资
      let emergency = this.$refs.emergency.verifyResult()
      if (!emergency.status) {
        return {
          status: false,
          msg: emergency.msg
        }
      }

      // 工艺和环境风险控制
      // let pross = this.$refs.process.verifyRes()
      // if(!pross.status) {
      // 	return {
      // 		status: false,
      // 		msg: pross.msg
      // 	}
      // }

      // 感目标区域
      if (!sessionStorage.save_st_res) {
        return {
          status: false,
          msg: '敏感目标区域信息不完善，请填写'
        }
      }
      if (sessionStorage.save_st_res) {
        let $res = JSON.parse(sessionStorage.save_st_res)
        for (let st in $res) {
          if (st == 'watersources' || st == 'rivers') {
            continue
          }
          if (!!!$res[st]) {
            return {
              status: false,
              msg: '敏感目标区域信息不完善，请填写'
            }

          }
        }
      }
      // 案例
      let casebox = this.$refs.case.verifyResult()
      if (!casebox.status) {
        return {
          status: false,
          msg: casebox.msg
        }
      }

      // 平面图
      let planbox = this.$refs.plan.verifyPlan()
      if (!planbox.status) {
        return {
          status: false,
          msg: planbox.msg
        }
      }

      //不验证
      // 应急队伍
      // let team = this.$refs.emergencyTeam.verifyResult()
      // if(!team.status) {
      // 	return {
      // 		status: false,
      // 		msg: team.msg
      // 	}
      // }

      // 全部通过
      return {
        status: true,
        msg: 'ok'
      }

    }, // 选中的情景
    changeArr(data) {
      this.form.situation = data.toString()
    },
    getLastSuccPlanRiskLevel() {
      console.log(this.saveButtonFlag)
      if (this.saveButtonFlag === true) {
        return;
      }
      console.log('getLastSuccPlanRiskLevel');
      (async () => {
        try {
          let info = await Burst.get_last_succ_plan_risk_level({
            subjectId: sessionStorage.subjectId
          })
          console.log(info.data)
          this.oldRiskLevel = info.data;
        } catch (err) {
          console.log(err)
        }
      })()
    },
    // 基本信息保存
    sudden_save(params) {
      (async () => {
        try {
          if (!sessionStorage.planIdval) return
          this.form.planId = sessionStorage.planIdval
          let info = await Burst.sudden_save(params)
          if (info.status) {
            this.isSave = true
            sessionStorage.setItem('simplifyFlag', info.data);
            this.form.simplifyFlag = info.data;
            this.$emit('updateFileLists');
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    sensprotection_list() {
      (async () => {
        try {
          let info = await Burst.get_sensprotection_list({
            planId: sessionStorage.planIdval
          })
          if (info.status && info.data) {
            sessionStorage.save_st_res = JSON.stringify(info.data)
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
  },
  components: {
    RiskMaterial,
    Emergency,
    EmergencyTeam,
    Sensprotection,
    planImg,
    process,
    casev
  }
}
</script>
<style scoped lang="stylus">
.weather-fill {
  text-align: left;
  margin: 20px 30px 20px 30px;
}

.el-checkbox,
.el-checkbox__input {
  white-space: normal
}

.el-form-item__content {
  position: relative;
  left: -15px;
}

.el-checkbox-group {
  label {
    display: block;
    line-height: 30px;

    &:nth-child(n+1) {
      margin-left: 0;
    }

    span {
      word-break: normal;
      width: auto;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow: hidden;
    }
  }
}

.b_p {
  position: relative;
  left: 0px;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// BurstFill.vue?469477a3